import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {BiSolidEdit} from 'react-icons/bi'
import {PiUserListFill} from 'react-icons/pi'

export const ViewRoleToggle = ({role, onChange}) => {
    const t = useTranslate()
    return (
        <div className="flex items-center background-100 rounded-lg p-0.5 flex-shrink-0">
            {[
                {key: 'admin', icon: <BiSolidEdit size={11}/>, label: t('admin')},
                {key: 'student', icon: <PiUserListFill size={11}/>, label: t('student')},
            ].map(opt => (
                <span
                    key={opt.key}
                    onClick={() => onChange(opt.key)}
                    style={{padding: '3px 10px', height: 26}}
                    className={classNames(
                        "flex items-center gap-1.5 rounded-md text-xs font-medium cursor-pointer transition-all",
                        role === opt.key
                            ? "bg-white shadow-sm text-color-000"
                            : "text-color-400 hover:text-color-100"
                    )}>
                    {opt.icon}
                    {opt.label}
                </span>
            ))}
        </div>
    )
}

// Secondary pill-style tab bar — intentionally lighter than the primary card tabs above
// tabs can have isAction: true for action-style tabs (e.g. modal triggers) that don't switch content
export const SecondaryTabBar = ({tabs = [], activeKey, onChange}) => (
    <div className="flex items-center gap-1 overflow-x-auto scrollbar-none">
        {tabs.map(tab => (
            <button
                key={tab.key}
                onClick={() => onChange(tab.key)}
                className={classNames(
                    "flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all whitespace-nowrap flex-shrink-0",
                    tab.isAction
                        ? "text-green-700 bg-green-50 hover:bg-green-100 border border-green-200 hover:border-green-300"
                        : activeKey === tab.key
                            ? "bg-primary-50 text-primary border border-primary-200"
                            : "text-color-400 hover:text-color-100 hover:bg-color-50 border border-transparent"
                )}>
                {tab.icon}
                {tab.label}
            </button>
        ))}
    </div>
)

// Combined header: secondary tabs left/top, role toggle right/bottom — stacks on mobile
export const CourseClassTabHeader = ({tabs, activeKey, onTabChange, role, onRoleChange, showTabs = true}) => (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2 mb-1">
        <div className="flex-1 min-w-0 overflow-hidden">
            {showTabs && <SecondaryTabBar tabs={tabs} activeKey={activeKey} onChange={onTabChange}/>}
        </div>
        <div className="flex justify-end flex-shrink-0">
            <ViewRoleToggle role={role} onChange={onRoleChange}/>
        </div>
    </div>
)
